import React, {useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Download as DownloadIcon } from '@mui/icons-material'
import { ItemType, ColumnItem } from '../../models/props.models'
import List, { ListMode, ListModeType } from '../common/List.common'
import { ordersService } from '../../store/orders'
import { FileDetails } from '../../models/files.models'
import { Filter } from '../../models/props.models'
import { ListProps } from '../common/List.common'

interface InventoryCheckResourceListProps extends Omit<ListProps, 'modes'| 'filter'| 'disabledPagination' > {
}


const InventoryCheckResourceList: React.FC<InventoryCheckResourceListProps> = ({
  getValues,
  ...listProps
}) => {
  const { t, i18n } = useTranslation()

  const resourceFilters = useMemo(
    () => ({
      items: [
        {
          type: ItemType.search,
          key: 'search',
          props: {
            placeholder: 'N°',
          },
          grid: { xs: 12, sm: 6, md: 3 },
        },
      ],
    }),
    [],
  )

  const columns = useMemo<ColumnItem[]>(
    () => [
      {
        label: t('inventoryChecks:resource.list.orderNumber'),
        key: 'orderNumber',
      },
      {
        label: t('inventoryChecks:resource.list.customer'),
        key: 'client',
        formatValue: (client: any) => client?.organization?.name || client?.name || '',
      },
      {
        label: t('inventoryChecks:resource.list.products'),
        key: 'name',
      },
      {
        label: t('inventoryChecks:resource.list.quantity'),
        key: 'quantity',
      },
      {
        label: t('inventoryChecks:resource.list.removalOrder'),
        key: 'removalOrder',
        formatValue: (removalOrder: FileDetails) => {
          if (!removalOrder) return null

          const handleClick = (e: React.MouseEvent) => {
            // specify the event only on this component
            e.stopPropagation()
            ordersService.downloadRemovalOrder(removalOrder)
          }

          return <DownloadIcon onClick={handleClick} style={{ fontSize: 20, cursor: 'pointer' }} />
        },
      },
    ],
    [t],
  )

  return (
      <List
        {...listProps}
        // add key to force re-mount, otherwise List doesn't update translations. Not the best practise
        key={i18n.language}
        getValues={getValues}
        filter={resourceFilters as Filter}
        disabledPagination={true}
        modes={[
          {
            key: 'resourceList',
            type: ListModeType.table,
            columns: columns,
          } as ListMode,
        ]}
      />
  )
}

export default InventoryCheckResourceList
